import { render } from "./chapter-list-menu.vue?vue&type=template&id=518b25b6&scoped=true&ts=true"
import script from "./chapter-list-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./chapter-list-menu.vue?vue&type=script&setup=true&lang=ts"

import "./chapter-list-menu.vue?vue&type=style&index=0&id=518b25b6&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b25b6"],['__file',"src/views/browse-view/components/chapter-list-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "518b25b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('518b25b6', __exports__)) {
    console.log('reload')
    api.reload('518b25b6', __exports__)
  }
  
  module.hot.accept("./chapter-list-menu.vue?vue&type=template&id=518b25b6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('518b25b6', render)
  })

}


export default __exports__